import React, { useContext } from "react";
import axios from "axios";
import Bread from "../../common/Bread";
import { useQuery } from "@tanstack/react-query";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "./memberNetwork.scss";
import Loader from "../../common/Loader";
import { LangContext } from "../../context/LangContext";

const MemberNetwork = () => {
  const lang = useContext(LangContext);
  const nep = lang.state.np; // true if Nepali is active

  const { isLoading, isFetching, error, data } = useQuery({
    queryKey: ["memberData"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/member_network`)
        .then((res) => res.data),
  });

  if (isFetching || isLoading) return <Loader />;
  if (error) return "An error has occurred: " + error.message;

  // Choose language-specific data
  const memberCategories = nep
    ? data?.member_network_category?.map((cat) => ({
        ...cat,
        title: cat.title_np,
        networks: cat.networks.map((net) => ({ ...net, title: net.title_np })),
      }))
    : data?.member_network_category;

  const breadcrumList = {
    image: "",
    title: nep ? "सदस्य नेटवर्क" : "Member Network",
    l1: nep ? "होम" : "Home",
    l2: nep ? "सदस्य नेटवर्क" : "Member Network",
    l3: "",
  };

  return (
    <Bread data={breadcrumList}>
      <div className="memberPageMainContainer">
        <Tabs className="tabs" defaultIndex={1}>
          <TabList className="tabList">
            {memberCategories?.map((value, index) => (
              <Tab key={index} className="button">
                {value.title}
              </Tab>
            ))}
          </TabList>

          {memberCategories?.map((item, index) => (
            <TabPanel key={index}>
              <div className="resultsContainer">
                {item.networks.length > 0 ? (
                  item.networks.map((i, idx) => (
                    <div key={idx} className="item">
                      <p>{i.title}</p>
                    </div>
                  ))
                ) : (
                  <h2>{nep ? "डाटा छैन" : "No data"}</h2>
                )}
              </div>
            </TabPanel>
          ))}
        </Tabs>
      </div>
    </Bread>
  );
};

export default MemberNetwork;
